<section class="contacto-public" aria-label="Líneas de atención">
  <app-header-public
    variant="v2"
    [showAuthButtons]="true"
    [showRegisterButton]="false"
  ></app-header-public>

  <div id="wrappedlinea" class="contacto-public__body">
    <div class="container">
      <div
        class="d-flex flex-column justify-content-center align-items-center horizontalSize"
      >
        <app-contacto-atencion-info
          kind="atencion"
          variant="page"
        ></app-contacto-atencion-info>
        <img
          src="./assets/img/page/informacion/Img_contacte_asesor_mobil.png"
          alt=""
          class="d-none d-lg-block wrappedlinea__decor"
        />
      </div>
    </div>
  </div>

  <app-home-site-footer></app-home-site-footer>
</section>
